import { render, staticRenderFns } from "./CompanyAdminAssignmentModal.vue?vue&type=template&id=44e6396e&scoped=true&"
import script from "./CompanyAdminAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./CompanyAdminAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e6396e",
  null
  
)

export default component.exports